import { useNavigate } from 'react-router-dom';
import useUserQuery from '../../hooks/queries/useUserQuery';
import { useGetUserIdentities } from '../../../domains/user/ui/hooks/useGetUserIdentities';
import { useBilling } from './useBilling';
import type { BillingKeyIssueRequest } from '../../../domain/models/payments/Billing';

interface UseInicisBillingPaymentProps {
  amount: string;
  productName: string;
  productId: string;
}

export const useInicisBillingPayment = ({
  amount,
  productName,
  productId
}: UseInicisBillingPaymentProps) => {
  const navigate = useNavigate();
  const { data: userIdentity, isLoading: isLoadingUserIdentities } = useGetUserIdentities();
  const { generateOrderId, getCurrentTimestamp, issueBillingKey } = useBilling();
  const { data: user, isLoading: isLoadingUser } = useUserQuery();

  const handleCreateOrder = async () => {
    if (!productId || isLoadingUserIdentities || !userIdentity || isLoadingUser) return;
    try {
      const orderId = await generateOrderId(productId);

      const payload: BillingKeyIssueRequest = {
        productId: productId,
        buyerName: userIdentity.name,
        buyerEmail: userIdentity.email,
        buyerTel: userIdentity.phoneNumber,
        goodName: productName,
        price: amount.toString(),
        orderId: orderId,
        timestamp: getCurrentTimestamp(),
        customData: user?.userId,
        merchantRedirectData: user?.userId
      };

      await issueBillingKey(payload);
    } catch {
      navigate('/payment/fail');
    }
  };

  return {
    handleCreateOrder,
    user
  };
};
